import React from 'react';
import { FiltersMap } from '@wix/bex-core';
import { ToolbarCollectionEmptyStateBasePrivateProps } from '../components/EmptyState/ToolbarCollectionEmptyStateBasePrivate';
import { EmptyStateProps } from '@wix/design-system';
import { MagnifyingGlassArt } from '../components/MagnifyingGlassArt';

interface ToolbarCollectionEmptyStateImageProps<F extends FiltersMap> {
  image: EmptyStateProps['image'];
  state: ToolbarCollectionEmptyStateBasePrivateProps<F>['state'];
}
export function useToolbarCollectionEmptyStateImage<F extends FiltersMap>(
  props: ToolbarCollectionEmptyStateImageProps<F>,
) {
  const { state, image } = props;
  const {
    hasAvailableItems,
    hasNonPersistentActiveFilters,
    resultOriginQuerySearch,
  } = state;

  if (
    hasAvailableItems &&
    (resultOriginQuerySearch != null || hasNonPersistentActiveFilters)
  ) {
    return <MagnifyingGlassArt data-hook="empty-state-glass-illustration" />;
  }
  return image;
}
